<template>
<nav class="navbar sticky-top ">
  <router-link class="navbar-brand white" to="/">
    <img src="@/assets/evermore_beauty_store/logo/ebs_logo_v2.png" alt="Evermore Beauty Store Logo"
      class="d-inline-block align-center mx-3 logo">
  </router-link>
  <div>
    <div>
      <router-link class="navbar-brand  align-text-center enlaceHeaderDesk " style="" to="/">
        ❀˖° Inicio ❀˖°
      </router-link> 
      <!--<router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Categorias">
        Categorias
      </router-link>
      <router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Marcas">
        Marcas
      </router-link>
      <router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Ubicaciones">
        Ubicaciones
      </router-link> -->
      <!--<router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Maquillaje">
        Maquillaje
      </router-link> -->
      <router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Sets">
        Sets Holidays 🎁🎄
      </router-link>
      <router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/SephoraSale">
        Sephora Sale 🛍
      </router-link>
      <router-link class="navbar-brand align-text-center  enlaceHeaderDesk " to="/Marcas">
        Marcas
      </router-link>

      
       <!--<button @click="handleOpenCart">
          🛒 Carrito ({{ itemCount }})
        </button>--> 
      

      <button class="switch" id="switch">
        <i class="switch-light bx bx-sun"></i>
        <i class="switch-dark bx bx-moon"></i>
      </button>
      <!-- <a class="navbar-brand align-text-center  enlaceHeaderDesk btnClientes "
        href="" >
        Clientes
      </a> -->
    </div>
  </div>

    <div class="menuMovil">    
      <div id="menuMovil__icon" @click="menu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div id="menuMovil__items" class="menuMovil__items">
      <div class="menuMovil__items__menu">
        <router-link class="navbar-brand white align-text-center" to="/">
          Inicio
        </router-link>
        <router-link class="navbar-brand align-text-center white" to="/Maquillaje">
          Maquillaje
        </router-link>
        <router-link class="navbar-brand white align-text-center" to="/Sets">
          Sets Holidays 🎁🎄
        </router-link>
        <router-link class="navbar-brand align-text-center white" to="/SephoraSale">
          Sephora Sale
        </router-link>
        <router-link class="navbar-brand align-text-center white" to="/Marcas">
          Marcas
        </router-link>
      </div>
      
    </div>

</nav>


</template>

<script>


  export default {
    setup () {
    },
    data(){
        return {
        isOpen: false
      };
    },
    name: 'Navbar',
    methods:{
    menu () {
      let menuMovil__icon = document.getElementById("menuMovil__icon");
      let menuMovil__items = document.getElementById("menuMovil__items");
      menuMovil__icon.classList.toggle("active");
      menuMovil__items.classList.toggle("active");
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    mounted() {
      var URLactual = window.location.pathname;
      URLactual = URLactual.substring(1);
      var arrayTextLink = document.querySelectorAll(".enlaceHeaderDesk");
      switch ( URLactual) {
          case "Sucursales" :
          arrayTextLink[1].classList.add("active")
          break;
          case "Parrilladas":
          arrayTextLink[2].classList.add("active")
            break;
          case "Contacto"  :
          arrayTextLink[3].classList.add("active")
            break;
        default:
            break;
        }
    },
  }
}

import { useCart } from '@/components/composables/cartStore';

const { toggleCart, itemCount } = useCart();

const handleOpenCart = () => {
  console.log("🟢 2. Clic detectado en el botón del Navbar");
  toggleCart();
};
</script>

<style>

</style> 